import { MainContext } from '@/store/main/actionsMain';
import {
  commitSetFeatureFlags,
  commitSetPollingInterval,
} from '@/store/main/mutations';
import { generalApi } from '@/lib/api/general';
import { readGetPollingInterval } from '@/store/main/getters';

export interface StatsigUserIdentity {
  userId: string;
  companyId: string;
  email: string;
}

export const actionUpdateFeatureFlags = async (
  context: MainContext,
  payload: { userId: string | null; companyId?: string }
): Promise<void> => {
  // using getFeatureFlagList API to get list of feature flags
  const response = await generalApi.getFeatureFlagList(
    payload.userId,
    payload.companyId
  );

  const flags: Record<string, boolean> = response.data;

  commitSetFeatureFlags(context, flags);
};

export const actionStartPollingOfFeatureFlags = (
  context: MainContext,
  userId: string | null,
  companyId?: string,
  intervalMs: number = 10 * 60 * 1000
): void => {
  actionStopPollingOfFeatureFlags(context);

  const interval = setInterval(() => {
    // update feature flags only if the tab is active
    if (!document.hidden) {
      actionUpdateFeatureFlags(context, { userId, companyId });
    }
  }, intervalMs);
  commitSetPollingInterval(context, interval);
};

export const actionStopPollingOfFeatureFlags = (context: MainContext): void => {
  const interval = readGetPollingInterval(context);
  if (interval) {
    clearInterval(interval);
    commitSetPollingInterval(context, null);
  }
};
